import React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

function Footer() {
  return (
    <>
      {/* <!-- Footer --> */}
      <footer className="footer">
        <ul className="footer-links">
          <li>
            <Link to="">Privacy</Link>
          </li>
          <span>|</span>
          <li>
            <Link to="">Help & Training</Link>
          </li>
          <span>|</span>
          <li>
            <Link to="">Make a Suggestion »</Link>
          </li>
        </ul>
      </footer>
      {/* <!-- End of Footer --> */}
    </>
  );
}

export default Footer;
